import * as dateMath from 'date-arithmetic';
import { RetsinfoHarvestRecord } from '../../../../../amorg-common';

export const retsinfoHelper = {

    getCutoffDate:(date:Date) => 
    {
        const now = new Date(date);
        return dateMath.add(now, -10, 'day');
    },

    getDateState:(record: RetsinfoHarvestRecord | null | undefined, date: Date) =>
    {
        const cutoffDate = retsinfoHelper.getCutoffDate(new Date());
        if(!record)
        {
            if (date < cutoffDate)
            {
                return 'no-record-outdated';
            }

            else
            {
                return 'no-record';
            }
        }
        else if (record.changes.length === 0)
        {
            return 'no-changes';
        }

        else
        {
            if (date < cutoffDate)
                return 'has-changes-outdated';

            else
                return 'has-changes';
        }
    }
};